<template>
  <Layout>
    <commission :commissionId="commissionId"></commission>
  </Layout>
</template>
<script>
import Layout from '../layouts/main'
import Commission from '../../components/commission'

export default {
  components: { Commission, Layout },
  name: 'commission-page',
  data () {
    return {
      commissionId: this.$route.params.id
    }
  }
}
</script>
